import React from "react";
import RouterCont from "./containers/routerCont/routerCont";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  typography: {
    fontFamily: ["Roboto", "sans-serif"].join(","),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouterCont />
    </ThemeProvider>
  );
}

export default App;
